import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const GoogleCallback = () => {
  const { t } = useTranslation();
  const [message, setMessage] = useState(t('processingLogin'));
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const tokens = params.get('tokens');
    const error = params.get('error');

    if (tokens) {
      const parsedTokens = JSON.parse(decodeURIComponent(tokens));
      localStorage.setItem('accessToken', parsedTokens.access);
      localStorage.setItem('refreshToken', parsedTokens.refresh);
      setMessage(t('loginSuccessful'));
      setTimeout(() => navigate('/dashboard'), 2000);
    } else if (error) {
      setMessage(t('loginFailed', { error: decodeURIComponent(error) }));
      setTimeout(() => navigate('/login'), 2000);
    }
  }, [location, navigate, t]);

  return (
    <div>
      <h2>{message}</h2>
    </div>
  );
};

export default GoogleCallback;